import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
const resources = {
  English: {
    translation: {},
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'English',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
